import { useEffect, useState } from 'react';
import { subscribe, flush, retryEntry, clearFailed, getState } from '../services/offlineQueue';

// Estado reactivo de la bandeja de salida offline para pintar avisos en la UI
// del técnico: { entries, pending, failed, flushing, flushNow, retry, clearFailed }.
export function useOfflineQueue() {
  const [state, setState] = useState(getState);

  useEffect(() => subscribe(setState), []);

  return {
    ...state,
    flushNow: flush,
    retry: retryEntry,
    clearFailed,
  };
}
